export default __webpack_public_path__ + "static/media/miguel-lopes-33.72d4112b.jpg";